/* eslint-disable import/no-extraneous-dependencies */
import { depotPlantType, updatedByUserType, getUserNotificationType } from 'pando-constants';

const plantType = depotPlantType();
const { BOTH, INBOUND, OUTBOUND } = getUserNotificationType();

export const fuelList = [
  {
    id: 1,
    name: 'Diesel',
    value: 1,
  },
  {
    id: 2,
    name: 'CNG',
    value: 2,
  },
  {
    id: 3,
    name: 'Petrol',
    value: 3,
  },
  {
    id: 4,
    name: 'Electric',
    value: 4,
  },
  {
    id: 5,
    name: 'LNG',
    value: 5,
  },
];

export const deliveryList = [
  {
    id: 1,
    name: 'FTL',
  },
  {
    id: 2,
    name: 'PTL',
  },
];
export const gstList = [
  {
    id: 1,
    name: 'FCM',
    tlabel: 'MDM_FCM',
  },
  {
    id: 2,
    name: 'RCM',
    tlabel: 'MDM_RCM',
  },
];
export const regions = [
  {
    id: 1,
    name: 'North',
  },
  {
    id: 2,
    name: 'South',
  },
  {
    id: 3,
    name: 'East',
  },
  {
    id: 4,
    name: 'West',
  },
];
export const customerType = [
  {
    id: 1,
    tlabel: 'MDM_SHIPPER_SITE',
    name: 'Shipper Site',
  },
  {
    id: 2,
    name: 'Customer Site',
    tlabel: 'MDM_CUSTOMER_SITE',
  },
  {
    id: 3,
    name: 'Co Maker Site',
    tlabel: 'MDM_CO_MAKER_SITE',
  },
  {
    id: 4,
    name: 'Hub',
    tlabel: 'MDM_HUB',
  },
];

export const hubTypeList = [
  {
    id: 1,
    tlabel: 'MDM_TRANSPORTER_HUB',
    name: 'Transporter Hub',
  },
];

export const gstExemptList = [
  {
    id: true,
    name: 'Yes',
    tlabel: 'MDM_YES',
  },
  {
    id: false,
    name: 'No',
    tlabel: 'MDM_NO',
  },
];

export const bdrSourceType = [
  {
    id: 'city',
    name: 'City',
    tlabel: 'MDM_CITY',
  },
  {
    id: 'state',
    name: 'State',
    tlabel: 'MDM_STATE',
  },
  {
    id: 'region',
    name: 'Region',
    tlabel: 'MDM_REGION',
  },
  {
    id: 'point',
    name: 'Point',
    tlabel: 'MDM_POINT',
  },
  {
    id: 'pincode',
    name: 'Pincode',
    tlabel: 'MDM_PINCODE',
  },
];

export const staticRole = {
  GATE_MANAGER: 'gate_manager',
  DOCK_MANAGER: 'dock_manager',
};
export const mdmType = {
  depot: 1,
  user: 2,
  material: 3,
  consignee: 4,
  transporter: 5,
  contract: 6,
  bucc: 7,
  detention: 8,
  loading: 9,
  sla: 10,
  exceptions: 11,
  contracttsd: 12,
  extra_drop_off_charge: 13,
  mdmlocation: 16,
  materialcategory: 17,
  blacklist_vehicle: 18,
  blacklist_driver: 19,
  purchase_order: 20,
  vehicle: 22,
  bfr: 23,
  driver: 24,
  transportationdb: 25,
  vehicledetail: 26,
  vendor_depots: 27,
  destination_charge: 28,
  package_master: 32,
  cha: 29,
  freightforwarder: 30,
  port: 31,
  activity_time: 34,
  transshipment: 35,
  dedicatedtruck: 41,
  transit_management: 43,
  redirection: 44,
  freight_zone: 45,
  legal_entity: 46,
  material_package_map: 47,
};

export const positioningConstraints = [
  {
    id: 1,
    name: 'None',
  },
  {
    id: 2,
    name: 'Horizontal',
  },
  {
    id: 3,
    name: 'Vertical',
  },
];


export const shortageDamageUnits = [
  {
    id: 1,
    name: 'None',
  },
  {
    id: 2,
    name: 'MT',
  },
  {
    id: 3,
    name: 'PCE/CASE',
  },
  {
    id: 4,
    name: 'QUANTITY UNIT',
  },
  {
    id: 5,
    name: 'PCE TO QUANTITY UNIT',
  },
];

export const plantTypes = [
  {
    id: plantType.DEPOT.id,
    label: plantType.DEPOT.text,
  },
  {
    id: plantType.RDC.id,
    label: plantType.RDC.text,
  },
  {
    id: plantType.FACTORY.id,
    label: plantType.FACTORY.text,
  },
];

export const utilizationCheckCategory = [
  {
    id: 0,
    name: 'NONE',
  },
  {
    id: 1,
    name: 'WEIGHT',
  },
  {
    id: 2,
    name: 'VOLUME',
  },
  {
    id: 3,
    name: 'WEIGHTANDVOLUME',
  },
  {
    id: 4,
    name: 'WEIGHTORVOLUME',
  },
];

export const updatedByUserTypes = [{
  id: updatedByUserType.SHIPPER,
  name: 'Shipper',
},
{
  id: updatedByUserType.TRANSPORTER,
  name: 'Transporter',
},
{
  id: updatedByUserType.SYSTEM,
  name: 'System',
}];

export const FleetTypes = [{ id: 0, label: 'Own Fleet', name: 'own' },
  { id: 1, label: 'Dedicated Fleet', name: 'dedicated' }, { id: 2, label: 'Market Fleet', name: 'market' }];

export const VehicleStatus = [
  {_id: 0, label: 'Active', name: 'ACTIVE'},
  {_id: 1, label: 'Inactive', name: 'INACTIVE'}
];

export const status = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

export const userNotificationPermissions = [BOTH, INBOUND, OUTBOUND];
